module.exports = {
      id: "stories-usage",
      viewBox: "0 0 33 27.835",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#stories",
      toString: function () {
        return this.url;
      }
    }